export const INBOX_BRIEF_REPORT = {
  headline: '4 emails need you · 5 meetings today',
  status: 'done',
  durationSec: 38,
  body: `**Good morning — 4 emails need a reply and you have 5 meetings today.**

### Needs a reply

| From | Subject | Why it matters |
|---|---|---|
| Meera Iyer (Northwind) | Pilot scope — final numbers? | Wants pricing for 40 seats by Thursday |
| Daniel Brooks (CFO) | Q3 forecast review | Asked for your pipeline view before 15:00 |
| Legal at Globex | MSA redlines v3 | Two clauses still open: liability cap, data residency |
| Sofia Martins | Re: conference talk | Needs your title and abstract today |

### FYI

- Kestrel Bank renewed for two years — the signed order form is in your inbox.
- 11 newsletters and 6 notifications archived.

### Today

- **09:30** Product sync — bring the onboarding drop-off numbers.
- **11:00** Northwind pilot check-in — expect a question on SSO timing.
- **13:30** 1:1 with Arjun — he wants to talk about the analytics roadmap.
- **15:00** Forecast review with Daniel — pipeline view due beforehand.
- **17:00** Interview: Senior Data Engineer — the scorecard is in Notion.`,
}
